export function validationFiltreListeProduitFace(errors, criteres) {
  if (!criteres.dateReferenceAffectation) {
    errors.push({
      message: 'listeProduitFace.filtre.errors.dateReferenceAffectation',
    });
  }
}

export function validationFiltreSuiviAffectationProduitFace(errors, criteres) {
  if (!(criteres.dateConsultation instanceof Date)) {
    errors.push({
      message: 'listeProduitFace.filtre.errors.datePivotAffectation',
    });
  }
}
